import { axios } from './axios';
import { PostCheckoutSurveyOption } from '../pages/types';

export const getPostCheckoutSurveyOptions = async (): Promise<PostCheckoutSurveyOption[]> => {
  const response = await axios.get<PostCheckoutSurveyOption[]>('/post_checkout_survey_options/');
  return response.data;
};

type CreatePostCheckoutSurveyOptionData = {
  label: string;
  value: string;
  marketing_source: string;
  marketing_bucket: string;
};

export const createPostCheckoutSurveyOption = async (data: CreatePostCheckoutSurveyOptionData) => {
  const response = await axios.post('/post_checkout_survey_options/', data);
  return response.data;
};

type UpdatePostCheckoutSurveyOptionData = {
  marketing_source?: string;
  marketing_bucket?: string;
};

export const updatePostCheckoutSurveyOption = async (
  id: string,
  data: UpdatePostCheckoutSurveyOptionData
) => {
  const response = await axios.patch(`/post_checkout_survey_options/${id}/update_marketing/`, data);
  return response.data;
};
